import React, { useEffect, useState } from "react";
import Heading from "../../components/common/Typography/Heading";
import MovingRight from "../../components/common/FullLengthSwipers/MovingRight";
import MovingLeft from "../../components/common/FullLengthSwipers/MovingLeft";
import img1 from "../../assets/img/default-image.jpg";
import SwiperCard from "../../components/common/AdsCard/SwiperCard";
import { GetRecentPosts } from "../../services/PostService";
import { useGraphQL } from "../../context/GraphQLProvider";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { SwiperCardSkeletonGrid } from "../../components/common/Skeleton/SwiperCardSkeleton";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SWIPER_CARD_MARGIN_CLASS,
  PUBLIC_CARD_OVERLAY_PADDING_CLASS,
  PUBLIC_SWIPER_AVATAR_ROW_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const ITEM_WIDTH = 250; // px, average width of each SwiperCard (adjust as needed)
const SLIDER_SPEED = 30; // px per second, desired constant speed

const LatestUpdates = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sliderSpeed, setSliderSpeed] = useState("50s");
  const graphqlService = useGraphQL();

  // Ref for heading
  const headingRef = useRef(null);
  const isHeadingInView = useInView(headingRef, { once: true, amount: 1 });

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await GetRecentPosts(graphqlService);
        if (response?.getRecentPosts?.posts) {
          setPosts(response.getRecentPosts.posts);
        }
      } catch (error) {
        console.error("Error fetching recent posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [graphqlService]);

  useEffect(() => {
    const totalWidth = posts.length * ITEM_WIDTH;
    const duration = totalWidth / SLIDER_SPEED; // seconds
    setSliderSpeed(`${duration}s`);
  }, [posts]);

  if (loading) {
    // return <div>Loading...</div>;
  }

  return (
    <>
      <div className={`w-[100%] ${PUBLIC_SECTION_GAP_CLASS}`}>
        <div className="tp-container-home mx-auto">
          {/* <motion.div
            ref={headingRef}
            initial={{ opacity: 0, y: 40 }}
            animate={isHeadingInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
            transition={{ duration: 1, ease: "easeOut" }}
          > */}
            <Heading variant={"h2"} className={"text-offblack"}>
              Browse Latest Posts
            </Heading>
          {/* </motion.div> */}
        </div>
        <div className={PUBLIC_HEADING_TO_CONTENT_CLASS}>
          {loading ? (
            // Show 2 rows of skeleton placeholders while loading
            <SwiperCardSkeletonGrid />
          ) : (
            // Show actual swipers when data is loaded
            <>
              <MovingLeft speed={sliderSpeed}>
                {posts.map((post, index) => (
                  <div className="sliderImg" key={post.id || index}>
                    <SwiperCard 
                      heading={post.postTitle} 
                      Images={JSON.parse(post.content)[0].url || img1}
                      company={post.user?.businessName}
                      category={post.user?.serviceCategory?.name}
                      userProfile={post.user?.profilePicture}
                      userPlan={post.user?.userPlan?.plan?.name}
                      postId={post.id}
                      userId={post.user?.id}
                      cardMarginClassName={PUBLIC_SWIPER_CARD_MARGIN_CLASS}
                      overlayPaddingClassName={PUBLIC_CARD_OVERLAY_PADDING_CLASS}
                      contentRowGapClassName={PUBLIC_SWIPER_AVATAR_ROW_GAP_CLASS}
                    />
                  </div>
                ))}
              </MovingLeft>
              <MovingRight speed={sliderSpeed}>
                {posts.map((post, index) => (
                  <div className="sliderImg" key={post.id || index}>
                    <SwiperCard 
                      heading={post.postTitle} 
                      Images={JSON.parse(post.content)[0].url || img1}
                      company={post.user?.businessName}
                      category={post.user?.serviceCategory?.name}
                      userProfile={post.user?.profilePicture}
                      userPlan={post.user?.userPlan?.plan?.name}
                      postId={post.id}
                      userId={post.user?.id}
                      cardMarginClassName={PUBLIC_SWIPER_CARD_MARGIN_CLASS}
                      overlayPaddingClassName={PUBLIC_CARD_OVERLAY_PADDING_CLASS}
                      contentRowGapClassName={PUBLIC_SWIPER_AVATAR_ROW_GAP_CLASS}
                    />
                  </div>
                ))}
              </MovingRight>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default LatestUpdates;
